import { PublicKey } from '@solana/web3.js';

const WRAPPED_SOL_MINT = new PublicKey('So11111111111111111111111111111111111111112');

export { WRAPPED_SOL_MINT };
//# sourceMappingURL=constants.mjs.map
